import { render, staticRenderFns } from "./AuthorInfoContent.vue?vue&type=template&id=4298dbfc&scoped=true"
import script from "./AuthorInfoContent.vue?vue&type=script&lang=js"
export * from "./AuthorInfoContent.vue?vue&type=script&lang=js"
import style0 from "./AuthorInfoContent.vue?vue&type=style&index=0&id=4298dbfc&prod&lang=scss&scoped=true"
import style1 from "./AuthorInfoContent.vue?vue&type=style&index=1&id=4298dbfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298dbfc",
  null
  
)

export default component.exports